import React from "react";
import "./StatusModalStyles.scss";
import close from "../../../../assets/close.png";
import arrow from "../../../../assets/arrow.png";

import { useSelector } from "react-redux";
import { RootState } from "../../../../../application/store";

interface StatusModalProps {
  isOpen: boolean;
  onClose: () => void;
  setStatus: React.Dispatch<React.SetStateAction<any>>;
  isEdit: boolean;
}

const StatusModal: React.FC<StatusModalProps> = ({
  isOpen,
  onClose,
  setStatus,
  isEdit,
}) => {
  const bookingStatus = useSelector(
    (state: RootState) => state.booking.bookingStatus
  );

  if (!isOpen) {
    return null;
  }

  return (
    <div className='status-modal-overlay' onClick={onClose}>
      <div
        className='status-modal-content'
        onClick={(e) => e.stopPropagation()}
        style={{ left: isEdit ? "37.2%" : "", top: isEdit ? "2rem" : "" }}
      >
        <div className='header'>
          <img alt='' src={close} onClick={onClose} />
        </div>
        <div className='content'>
          {bookingStatus.map((status, index) => {
            return (
              <div key={index}>
                <div className='cat'>
                  {status.Name} <img alt='' src={arrow} />
                </div>
                {status.Statuses.length > 0 && (
                  <div className='items'>
                    {status.Statuses.map((item: any, indexKey: number) => {
                      return (
                        <div
                          className='item-cat'
                          key={indexKey}
                          style={{
                            color: item.Color,
                            backgroundColor: `${item.Color}1A`,
                          }}
                          onClick={() => {
                            setStatus(item);
                            onClose();
                          }}
                        >
                          <img alt='' src={item.Image} />
                          {item.DisplayName}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default StatusModal;
